var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('ChartLayout',{attrs:{"title":"CO2 from energy combustion and industrial processes, Global Energy and Climate Model scenarios compared to IPCC scenarios with a temperature rise of 1.5 °C and 2.0 °C in 2100","units":"Gt CO2"},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('ChartLegend',{attrs:{"legendItems":[
          { name: 'Net Zero Emissions by 2050 Scenario', colorIndex: 2 },
          { name: 'Announced Pledges Scenario', colorIndex: 5 },
        ]}})]},proxy:true},{key:"notes",fn:function(){return [_c('p',[_vm._v(" The 1.5°C scenarios are IPCC-vetted Category C1 scenarios (1.5°C with no or limited overshoot) and the 2°C IPCC Scenarios are IPCC-vetted Category C3 scenarios from the Sixth Assessment Report (AR6). Source: IIASA (International Institute for Applied Systems Analysis) (2022), AR6 Scenarios Database hosted by IIASA. ")])]},proxy:true}])},[_c('figure',{staticClass:"half-charts"},[_c('Chart',{attrs:{"options":{
          ..._vm.options,
          subtitle: { text: 'IEA scenarios vs. IPCC 1.5°C scenarios' },
          series: _vm.series15,
        }}}),_c('Chart',{attrs:{"options":{
          ..._vm.options,
          subtitle: {
            text: 'IEA scenarios vs. IPCC 2.0°C scenarios',
          },
          yAxis: {
            title: { text: null },
            labels: { enabled: false },
            max: 50,
            min: -20,
            plotLines: [
              { value: 0, className: 'highcharts-zero-axis', zIndex: 99 },
            ],
          },
          series: _vm.series20,
        }}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }